/**
 * @file コンポーネント：フル動画ページノートポップアップ DOM管理
 */

// ライブラリ読み込み
import React from "react";

// コンポーネント読み込み
import { Note } from "~/src/components/projects/Note";
import { Popup } from "~/src/components/projects/Popup";

// スタイル読み込み
import { StyledPopup } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <Popup
            content={[
                <StyledPopup key="content" ref={props.refPopupContent}>
                    {/* ノート本体 */}
                    <Note
                        fnJump={props.fnJump}
                        hasAddTimeline={true}
                        isLoadingFullvideo={props.isLoadingFullvideo}
                        operationId={props.operationId}
                        timeProgress={props.timeProgress}
                    />
                </StyledPopup>,
            ]}
            headline={props.operationTitle}
            isOpen={props.isOpenPopupNote}
            setIsOpen={props.setIsOpenPopupNote}
        />
    );
};
